G.Ice = function(layer, cellX, cellY, hp) {
  G.BoardToken.call(this, layer, {
    tokenType: "ice",
  }, cellX, cellY, hp);

  G.changeTexture(this, "ice_front");

  this.breakImg = G.makeImage(0, 0, null, 0.5, this);
  if (this.hp < 4) {
    G.changeTexture(this.breakImg, "ice_crack_"+this.hp);
  }
};

G.Ice.prototype = Object.create(G.BoardToken.prototype);

G.Ice.prototype.onHit = function() {
  G.sfx.explosion_subtle.play();

  G.sb("fxTop").dispatch('burstIce',this,this);

  this.hp--;
  if (this.hp > 0) {
    G.changeTexture(this.breakImg,'ice_crack_'+this.hp);
  }else {
    G.sb("fx").dispatch('smallCircle',this);
    this.remove();
  }
};

G.Ice.prototype.onBooster = function() {
  this.onHit();
  return false;
};